import { ButtonWithTooltip, RedoButton, RefreshButton, SaveButton, UndoButton } from "Components/button";
import classNames from "classnames";
import React, { memo, useCallback, useEffect } from "react";
import locale from "./rowActionsPanel.locale";
import Styled, { SIZES } from "./rowActionsPanel.styled";
function RowActionsPanel(props) {
    useEffect(() => {
        const sendToGraphElement = document.querySelector(props.sendToGraphSelector);
        sendToGraphElement && sendToGraphElement.setAttribute("disabled", "disabled");
    }, [props.sendToGraphSelector]);
    const handleSendToGraphTooltipShowing = useCallback((e) => {
        var _a;
        const sendToGraphElement = document.querySelector(props.sendToGraphSelector);
        if (!sendToGraphElement)
            return;
        const content = (_a = e.component.instance()) === null || _a === void 0 ? void 0 : _a.content();
        if (!content)
            return;
        content.innerText = sendToGraphElement.getAttribute("disabled")
            ? locale.SELECT_FOR_APPEND_TO_GRAPH
            : locale.APPEND_TO_GRAPH;
    }, []);
    return (React.createElement(Styled.ActionsMiniPanel, { className: classNames("bg-light-surface", props.className), hasRightSidePanel: Boolean(props.rightSidePanel), panelHeight: props.rowActionsPanelHeight },
        React.createElement("div", { className: "grid-cols-auto no-gap overflow-hidden" },
            React.createElement(SaveButton, { onSave: props.onSave, disabled: !props.onSave, btnSize: SIZES.BTN_SIZE, className: "btn-arrow-action" }),
            React.createElement(RefreshButton, { onRefresh: props.onRefresh, disabled: !props.onRefresh, btnSize: SIZES.BTN_SIZE, needConfirm: Boolean(props.onSave), className: "btn-arrow-action" }),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(UndoButton, { onUndo: props.onUndo, disabled: !props.onUndo, btnSize: SIZES.BTN_SIZE, className: "btn-arrow-action" }),
            React.createElement(RedoButton, { onRedo: props.onRedo, disabled: !props.onRedo, btnSize: SIZES.BTN_SIZE, className: "btn-arrow-action" }),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(ButtonWithTooltip, { height: SIZES.BTN_SIZE, width: SIZES.BTN_SIZE, className: "btn-arrow-action", onClick: props.onDelete, disabled: !props.onDelete, popoverContent: locale.DELETE },
                React.createElement("i", { className: "icon-trash font-h5" })),
            React.createElement("div", { className: "vertical-divider" }),
            React.createElement(ButtonWithTooltip, { height: SIZES.BTN_SIZE, width: SIZES.BTN_SIZE, className: "btn-arrow-action", popoverContent: locale.SELECT_FOR_APPEND_TO_GRAPH, elementAttr: props.sendToGraphButtonAttrs, onShowing: handleSendToGraphTooltipShowing },
                React.createElement("i", { className: "icon-export-arrow font-h5" }))),
        props.rightSidePanel));
}
export default memo(RowActionsPanel);
